<template>
  <div class="ti d-flex">
    <div class="d-flex-left">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="d-flex-right" style="margin-top: 10px;">
      <el-button @click="selects(1)">查询</el-button>
      <el-button @click="examine()">提交审核</el-button>
      <el-button @click="revoke()">撤销未提交的调整</el-button>
      <el-button @click="revoke_examine(1)">撤销审核(拒绝)-当前房产</el-button>
      <el-button @click="revoke_examine(2)">撤销审核(拒绝)-(全部)</el-button>
      <el-button @click="examine_all(1)" v-if="ERP.isPermission(4003007012)">审核(当前房产)</el-button>
      <el-button @click="examine_all(2)" v-if="ERP.isPermission(4003007013)">审核(全部)</el-button>
      <div>
          <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
            <el-descriptions-item  label="显示">
              <RadioGroup v-model="select.frozen">
                  <Radio label="当前房产"></Radio>
                  <Radio label="待提交审核"></Radio>
                  <Radio label="待审核"></Radio>
                  <Radio label="待审核(全部)"></Radio>
              </RadioGroup>
            </el-descriptions-item>
            <el-descriptions-item label="房产信息">
              <el-select v-model="select.house" size="mini" placeholder="可搜索房产" filterable remote clearable reserve-keyword :remote-method="remoteMethod" style="width: 100%;">
                  <el-option v-for="item in house" :key="item.id" :label="item.house" :value="item.house"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item  label="计费周期">
              <el-date-picker v-model="select.startDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
              <span style="margin-left: 1px;margin-right: 1px;">至</span>
              <el-date-picker v-model="select.endDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="收费项目">
              <el-select v-model="select.chargeitem_id" size="mini" multiple filterable collapse-tags placeholder="收费项目" style="width: 90.5%;">
                  <el-option v-for="item in chargeitem" :key="item.id" :label="item.chargeItem_name" :value="item.id"></el-option>
              </el-select>
              <span style="cursor: pointer;margin-left: 3px;" @click="complete">全选</span>
              <span style="margin-left: 3px; cursor: pointer" @click="cancel">取消</span>
            </el-descriptions-item>
            <el-descriptions-item :labelStyle="{color: 'red'}" label="调整业户">
              <el-button style="color: red;" @click="user_update()">更改业户</el-button>
              <el-button @click="adduser()">新增业户</el-button>
              <span v-if="text" style="color: red;margin-left: 10px;">{{text}}</span>
            </el-descriptions-item>
            <el-descriptions-item  label="账单状态">
              <RadioGroup v-model="select.stutes">
                  <Radio label="全部"></Radio>
                  <Radio label="待付款"></Radio>
                  <Radio label="部分缴款"></Radio>
                  <Radio label="已缴款"></Radio>
              </RadioGroup>
            </el-descriptions-item>
          </el-descriptions>
      </div>
      <div style="margin-top: 10px;">
        <span>选中金额：<span style="color: red;">{{money_val}}</span>元</span>
        <span style="margin-left: 15px;">总金费：<span style="color: red;">{{money}}</span>元</span>
        <span style="margin-left: 15px;color: red;" v-if="loading_dade==2">加载中...</span>
        <el-table ref="multipleTable" :data="tableData" border tooltip-effect="dark" style="width: 100%" height="50vh"  @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="customer1" label="姓名" width="100"></el-table-column>
          <el-table-column prop="customer2" label="调整后姓名" width="100"></el-table-column>
          <el-table-column prop="customer3" label="审核前" width="100"></el-table-column>
          <el-table-column label="调整状态" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.stute_name == '未调整'">未调整</span>
              <span v-if="scope.row.stute_name == '待提交'" style="color: #07685b;">待提交审核</span>
              <span v-if="scope.row.stute_name == '审核中'" style="color: red;">审核中</span>
            </template>
          </el-table-column>
          <el-table-column prop="user" label="提交人" width="100"></el-table-column>
          <el-table-column prop="checks" label="审核人" width="100"></el-table-column>
          <el-table-column prop="h_name_date" label="房产" show-overflow-tooltip></el-table-column>
          <el-table-column prop="chargeitem_name" label="收费项目" width="130"></el-table-column>
          <el-table-column label="计费周期" width="150">
            <template slot-scope="scope">
              {{scope.row.startDate}}-{{scope.row.endDate}}
            </template>
          </el-table-column>
          <el-table-column prop="account_book" label="所属日期" width="100"></el-table-column>
          <el-table-column prop="month_end_date" label="月结日期" width="100"></el-table-column>
          <!-- <el-table-column prop="xsc_Price" label="单价" width="70"></el-table-column>
          <el-table-column prop="xsc_Amount" label="数量" width="70"></el-table-column> -->
          <el-table-column prop="charge_adjust_after" label="金额" width="70"></el-table-column>
          <el-table-column prop="PaidChargeSum" label="已缴金额" width="70"></el-table-column>
        </el-table>
      </div>
      <div class="pages">
        <Page :total="total" :page-size="page" @on-change="selects" show-total />
      </div>
    </div>
    <!-- 新增业户 -->
    <AddCustomerWindow ref="AddCustomerWindow" />
    <!-- 弹窗选择用户 -->
   <Modal v-model="modal1" width="950" title="选择客户" @on-ok="roomUser" :z-index="100000000000000">
      <div>
        <room-user
          style="height: 600px"
          ref="child"
          :house="select.house"
        ></room-user>
      </div>
    </Modal>
  </div>
</template>

<script>
  export default {
      // 接受父组件的值
      props: {

      },
      watch:{

      },
      components: {
        "AddCustomerWindow": () => import('../../Common/AddCustomerWindow'),
        "room-user": () => import("../../Common/room-user.vue"),
        "erp-tree": () => import('../../Common/erp-tree.vue'),
      },
      data () {
        return {
          modal1:false,
          total:0,
          page:200,
          dialogVisible:false,
          tableData: [],
          order: [],
          money_val:0,
          money:0,
          select:{
            startDate:'',
            endDate:'',
            pay:'',
            house:'',
            name:'',
            date:'',
            page:1,
            chargeitem_id:[],
            frozen:"当前房产",
            stutes:"待付款"
          },
          text:'',
          customer:[],
          dataPay:[],
          xsc_bill_no:'',
          house:[],
          chargeitem:[],
          loading:false,
          loading_dade:1
        }
      },
      mounted(){
        let house = this.$route.query.house;
        if(house){
          this.select.house = house;
          this.selects(1);
        }
        //加载收费大类（费项）
        this.$myhttp
          .get("admin/common/getChargeitem", {
            "Content-Type": "application/json",
          })
          .then((backdata) => {
            this.chargeitem = backdata.data.data;
          });
      },
      //事件
      methods: {
        //点击树
        nodeClick(data){
          let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
          this.select.house = tree_str;
          this.selects(1);
        },
        //新增业户
        adduser(){
          const that=this;
          let type = 1;
          that.$refs.AddCustomerWindow.show(type,data=>{
            // that.form_2.customer_id=data.customer_id;
            // that.form_2.customer_name=data.name;
          })
        },
        //选择业户
        user_update(){
          if(this.order.length < 1){
            this.text = "请勾选要修改的账单";
            return false;
          }
          this.text = '';
          this.modal1 = true;
        },
        roomUser() {
          let user = this.$refs.child.getUser();
          if (user.id) {
            let data = {};
            data.user_id = user.id;
            data.user = user.name;
            let datas = {'data':data,'order':this.order}
            this.$myhttp.post('admin/OrderUsers/add',datas,{
              'Content-Type': 'application/x-www-form-urlencoded'
              }).then(backdata=>{ // 异步执行成功后
                this.loading_dade = 1;
                this.selects(this.select.page);
            },err=>{
              this.loading_dade = 1;
              this.$Message.error('请求异常!');
            });
          }
        },
        //撤销未提交
        revoke(){
          this.$confirm('确定要操作吗, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
           this.loading_dade = 2;
           this.$myhttp.post('admin/OrderUsers/revoke',this.select,{
             'Content-Type': 'application/x-www-form-urlencoded'
             }).then(backdata=>{ // 异步执行成功后
               this.loading_dade = 1;
               this.selects(this.select.page);
               this.$Message.success(backdata.data.message);
           },err=>{
             this.loading_dade = 1;
             this.$Message.error('请求异常!');
           });
          })
        },
        //撤销审核中的
        revoke_examine(e){
          this.$confirm('确定要操作吗, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
           this.loading_dade = 2;
           this.select.revoke_examine = e;
           this.$myhttp.post('admin/OrderUsers/revoke_examine',this.select,{
             'Content-Type': 'application/x-www-form-urlencoded'
             }).then(backdata=>{ // 异步执行成功后
               this.loading_dade = 1;
               this.selects(this.select.page);
               this.$Message.success(backdata.data.message);
           },err=>{
             this.loading_dade = 1;
             this.$Message.error('请求异常!');
           });
          })
        },
        //提交审核
        examine(){
          this.$confirm('确定要操作吗, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
           this.loading_dade = 2;
           this.$myhttp.post('admin/OrderUsers/examine',this.select,{
             'Content-Type': 'application/x-www-form-urlencoded'
             }).then(backdata=>{ // 异步执行成功后
               this.loading_dade = 1;
               this.selects(this.select.page);
               this.$Message.success(backdata.data.message);
           },err=>{
             this.loading_dade = 1;
             this.$Message.error('请求异常!');
           });
          })
        },
        //审核
        examine_all(e){
          this.$confirm('确定要操作吗, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
           this.loading_dade = 2;
           this.select.examine_all = e;
           this.$myhttp.post('admin/OrderUsers/examine_all',this.select,{
             'Content-Type': 'application/x-www-form-urlencoded'
             }).then(backdata=>{ // 异步执行成功后
               this.loading_dade = 1;
               this.selects(this.select.page);
               this.$Message.success(backdata.data.message);
           },err=>{
             this.loading_dade = 1;
             this.$Message.error('请求异常!');
           });
          })
        },
        //返回数据
        getInvo(house){
          this.select.house = house[0].house;
          this.dialogVisible = true;
          this.selects(1);
        },
        del(){
          this.select.pay = '';
        },
        //全选
        complete() {
          let data = this.chargeitem;
          let id = data
            .map((ret) => {
              return ret.id;
            })
            .join(",");
          let idarray = "[" + id + "]";
          this.select.chargeitem_id = JSON.parse(idarray);
        },
        //取消
        cancel() {
          this.select.chargeitem_id = [];
        },
        // 查询
        selects(e){
          this.loading_dade = 2;
          this.select.page = e;
          this.$myhttp.post('admin/OrderUsers/index',this.select,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.loading_dade = 1;
              this.tableData = backdata.data.data;
              this.total = backdata.data.count;
              this.money = backdata.data.money;
          },err=>{
            this.loading_dade = 1;
            this.$Message.error('请求异常!');
          });
        },
        handleClose(done) {
          done();
        },
        handleSelectionChange(val) {
          this.order = val;
          let money = 0;
          this.order.map(req=>{
              money = Number(money) + Number(req.charge);
          })
          this.money_val = money.toFixed(2);
        },
        //远程搜索
        remoteMethod(query){
          if (query !== '') {
            this.$myhttp.get('admin/common/house_name1?house_name='+encodeURIComponent(query),{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                this.house = backdata.data.data;
            });
          }
        },
    },
  }
</script>

<style>
  .d-flex {
    display: flex;
  }
  .d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
    width: 250px;

  }
  .d-flex-right {
    flex: 1;
    overflow-x:hidden;
  }
  .text2{
    color: rgb(250, 248, 248);
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/Users.vue